<template>
  <div>
    <content-left-menu/>
    <router-view></router-view>
  </div>
</template>
<script>
  import ContentLeftMenu from './ContentLeftMenu';
  export default {
    name: 'content-layout',
    components: {
      ContentLeftMenu
    }
  }
</script>
<style>
</style>
